export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 110,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('form_label_isSchedule') || '行程状态',
    field: 'isSchedule',
    width: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: {
      default: 'isSchedule'
    }
  },
  {
    title: that.$l('table_label_schedule_showScheduleInfo') || '行程安排',
    field: 'city',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: {
      default: 'showScheduleInfo'
    }
  },
  {
    title: that.$l('table_label_schedule_showCustInfo') || '工厂/客户/订单',
    field: 'custName',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    slots: {
      default: 'showCustInfo'
    }
  },
  {
    title: that.$l('table_label_brand') || '品牌',
    field: 'brandName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_depCode') || '分摊部门',
    field: 'depName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_ticketFee') || '机票车票费',
    field: 'v_ticketFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_trafficFee') || '交通费',
    field: 'v_trafficFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_hotelFee') || '住宿费',
    field: 'v_hotelFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_travellingAllowance') || '住勤补贴',
    field: 'v_travellingAllowance',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_otherFee') || '其他',
    field: 'v_otherFee',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_subAmount') || '合计金额',
    field: 'v_subAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_billCount') || '单据张数',
    field: 'billCount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_expenseRemark') || '费用说明',
    field: 'expenseRemark',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    showHeaderOverflow: true,
  }
]
